export function notionImportFailureMessage(status: number, bodyText: string, path: string): string {
  let detail = bodyText.trim();
  let code: string | undefined;
  try {
    const json = JSON.parse(bodyText) as { error?: { code?: string; message?: string } };
    if (json.error?.message) {
      detail = json.error.message;
    }
    code = json.error?.code;
  } catch {
    // plain text body
  }

  if (code) {
    return detail || `${status} ${path}`;
  }
  if (status === 404) {
    return `API route not found (${path}). Restart or redeploy the API server so /rpc/import routes are available. ${detail}`.trim();
  }
  return `${status} ${path}: ${detail}`.trim();
}
